export const IPS_ITEMS = [
  {
    title: 'Operacional',
    itens: [
      {
        label: 'Trades',
        icon: 'description',
        route: 'pedidos',
        materialIcon: true,
        flag: 'OT',
      },
      {
        label: 'Triagem',
        icon: 'collections_bookmark',
        materialIcon: true,
        route: 'triagem/buscar',
        flag: 'OTR',
      },
      {
        label: 'Precificação',
        icon: 'request_quote',
        materialIcon: true,
        route: 'precificacao',
        flag: 'OP',
      },
      {
        label: 'Usuários',
        icon: 'supervisor_account',
        route: 'acessos/usuarios',
        materialIcon: true,
        flag: 'OU',
      },
      {
        label: 'Janela de decisão',
        icon: 'collections_bookmark',
        materialIcon: true,
        route: 'reaberturas',
        flag: 'OJD',
      },
    ],
  },
  {
    title: 'Relatórios',
    itens: [
      {
        label: 'Financeiro Apple',
        icon: 'request_quote',
        route: 'relatorio/financeiro',
        materialIcon: true,
        flag: 'RF',
      },
      {
        label: 'Relatório de Trades',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/pedidos',
        flag: 'RT',
      },
      {
        label: 'Relatório Resumido',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/resumido',
        flag: 'RR',
      },
      {
        label: 'Relatório de Divergências',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/divergencias',
        flag: 'RD',
      },
      {
        label: 'Relatório Opção Ficar',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/opcao-ficar',
        flag: 'ROF',
      },
      {
        label: 'Relatório de Verbas',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/budget',
        flag: 'RV',
      },
      {
        label: 'Linha do tempo',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/timeline',
        flag: 'RLT',
      },
      {
        label: 'Erros',
        icon: 'assignment',
        materialIcon: true,
        route: 'erros',
        flag: 'RE',
      },
      {
        label: 'Logs',
        icon: 'assignment',
        materialIcon: true,
        route: 'logs',
        flag: 'RL',
      },
    ],
  },
];
